<template lang="pug">
  div(:class="{ 'has-error': !valid, 'form-group': true }")
    v-select-styled(
      :class="{ 'fix-height-div': !multiple }",
      :value="value",
      @input="$emit('input', $event)",
      :on-search="onSearch",
      :label="displayField",
      max-height="270px",
      :field-label="label",
      :options="itemsChoice",
      :withPreloading="true"
      :clearable="clearable"
    )

</template>

<script>
    import vSelectStyled from '@/components/vSelectStyled';
    import { getAjaxSearchMethod } from '@/utils/vSelect';

    export default {
        name: 'SelectInput',

        props: {
            value: {
                type: Object
            },
            label: {
                type: String
            },

            valueField: {
                type: String,
                default: 'id'
            },
            displayField: {
                type: String,
                default: 'name'
            },

            filters: {
                type: Array
            },

            valid: {
                type: Boolean,
                default: true
            },
            message: {
                type: String,
                default: ''
            },

            multiple: {
                type: Boolean,
                default: false
            },
            searchPath: {
                type: String,
                default: ''
            },
            clearable: {
                type: Boolean,
                default: true
            }
        },

        components: {
            vSelectStyled
        },

        methods: {
            onSearch: getAjaxSearchMethod()
        },

        data() {
            return {
                itemsChoice: []
            };
        }
    };
</script>

<style lang="stylus">
  .fix-height-div
    .dropdown-toggle
      max-height 33px
</style>



// WEBPACK FOOTER //
// src/lib/fields/SelectInput.vue